import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'PICChild',
    label: 'PICChild',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
